import { Routes } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { provideTaskActionHandlers } from './core/utils/provide-task-action-handlers.function';
import { provideTaskSummaryRenderers } from './core/utils/provide-task-summary-renderers.function';
import { provideTaskMappers } from './core/utils/provide-task-mappers.function';
import { provideTaskDetailsRenderers } from './core/utils/provide-task-details-renderers.function';
import { taskEffects } from './core/store/task.effects';
import { taskReducer } from './core/store/task.reducer';
import { TaskAdapterService } from './core/services/task-adapter.service';
import { TasksService } from './core/services/tasks.service';

export const TASKS_ROUTES: Routes = [
  {
    path: '',
    providers: [
      provideState({ name: 'task', reducer: taskReducer }),
      provideEffects(taskEffects),
      provideTaskActionHandlers(),
      provideTaskSummaryRenderers(),
      provideTaskMappers(),
      provideTaskDetailsRenderers(),
      TaskAdapterService,
      TasksService,
    ],
    loadComponent: () => import('./pages/tasks.component').then(c => c.TasksComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/tasks-overview/tasks-overview.component').then(c => c.TasksOverviewComponent),
      },
      {
        path: ':taskId',
        loadComponent: () => import('./pages/task-hub/task-hub.component').then(c => c.TaskHubComponent),
      },
    ],
  },
];
